import { Component, Input, OnInit } from '@angular/core';
import { FormFieldNumberComponent } from '../number/form-field-number.component';

@Component({
    selector: 'lib-input-decimal',
    templateUrl: './form-field-decimal.component.html',
    styleUrls: ['./form-field-decimal.component.scss']
})
export class FormFieldDecimalComponent extends FormFieldNumberComponent implements OnInit {
    @Input() override minDecimalPlaces: number = 2;
    @Input() override maxDecimalPlaces: number = 2;

    constructor() {
        super();

        this.errors.Override({
            min: (value: {min: number, actual: number}) =>
                $localize`:@@CommonInputDecimalValueTooSmallInclusive:Please enter an amount greater than or equal to ${this.ValueFormatter(value.min)}.`,
            minExclusive: (value: {min: number, actual: number}) =>
                $localize`:@@CommonInputDecimalValueTooSmallExclusive:Please enter an amount greater than ${this.ValueFormatter(value.min)}.`,
            max: (value: {max: number, actual: number}) =>
                $localize`:@@CommonInputDecimalValueTooLargeInclusive:Please enter an amount less than or equal to ${this.ValueFormatter(value.max)}.`,
            maxExclusive: (value: {max: number, actual: number}) =>
                $localize`:@@CommonInputDecimalValueTooLargeExclusive:Please enter an amount less than ${this.ValueFormatter(value.max)}.`
        });
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.GetRegexForValidation();
    }

    private GetRegexForValidation(): void {
        let decimalSeparator = this._LocalizationService.NumberFormatInfo.DecimalSeparator;

        //Follow this format ^(\d+)(\.\d{0,4})?$
        let decimalRegex: string;
        if (this.maxDecimalPlaces > 0) {
            decimalRegex = `^${this.allowNegativeInput ? '-?' : ''}(\\d+([${decimalSeparator}]\\d{0,${this.maxDecimalPlaces}})?|[${decimalSeparator}]\\d{0,${this.maxDecimalPlaces}})${this.allowNegativeInput ? '?' : ''}$`;
        } else {
            decimalRegex = `^${this.allowNegativeInput ? '-?' : ''}(\\d+)${this.allowNegativeInput ? '?' : ''}$`;
        }

        this._validationRegex = new RegExp(decimalRegex, 'g');
    }
}
